/* tslint:disable */
import {
  Institutions
} from '../index';

declare var Object: any;
export interface InstitutionVersionInterface {
  "json_string": string;
  "id"?: number;
  "institution_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  institution?: Institutions;
}

export class InstitutionVersion implements InstitutionVersionInterface {
  "json_string": string;
  "id": number;
  "institution_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  institution: Institutions;
  constructor(data?: InstitutionVersionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `InstitutionVersion`.
   */
  public static getModelName() {
    return "InstitutionVersion";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of InstitutionVersion for dynamic purposes.
  **/
  public static factory(data: InstitutionVersionInterface): InstitutionVersion{
    return new InstitutionVersion(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'InstitutionVersion',
      plural: 'InstitutionVersions',
      path: 'InstitutionVersions',
      properties: {
        "json_string": {
          name: 'json_string',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "institution_id": {
          name: 'institution_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        institution: {
          name: 'institution',
          type: 'Institutions',
          model: 'Institutions'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/InstitutionVersion.ts